import SelectApplicantButton from './select-applicant-button.view';

export default SelectApplicantButton;
